"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabPanels = void 0;
var _TabPanels = require("./TabPanels");
// TODO: in v9, move styled() from TabPanels.jsx to here
var StyledTabPanels = _TabPanels.TabPanels;
exports.StyledTabPanels = StyledTabPanels;